import * as React from 'react';

interface TimerState {
    minutes: number;
    seconds: number;
}

export default function useIncrementingTimer(startTime: string | undefined) {
    const [timer, setTimer] = React.useState<TimerState>({
        minutes: 0,
        seconds: 0,
    });

    React.useEffect(() => {
        const math = Math;
        let interval: any;

        if (startTime) {
            const startTimeMilliseconds = Date.parse(startTime); //.getTime();

            interval = setInterval(() => {
                const time = math.floor((Date.now() - startTimeMilliseconds) / 1000);
                const minutes = math.floor(time / 60);
                const seconds = math.floor(time % 60);

                setTimer({ minutes, seconds });
            }, 1000);
        }

        return () => {
            clearInterval(interval);
        };
    }, [startTime]);

    return timer;
}
